import {
  getAccountsUrl,
  getCrmUrl,
  getInsightsUrl,
  getPerspectiveUrl,
  getUnisonUrl,
} from '@/api/urls';

export const PLATFORMS = {
  CRM: `${getCrmUrl()}/dashboard/overview`,
  INSIGHTS: `${getInsightsUrl()}/dashboard/overview`,
  UNISON: getUnisonUrl(),
  PERSPECTIVE: getPerspectiveUrl(),
  ACCOUNTS: getAccountsUrl(),
};
